/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acted Core API
 * Core backend API.
 * OpenAPI spec version: 1.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  AddRoleRequestRequest,
  PaginatedUserList,
  RemoveRoleRequestRequest,
  User,
  UsersListParams
} from '../model';

import {
  environment
} from 'environments/environment';



import { filterParams, HttpClientBodyOptions, HttpClientEventOptions, HttpClientObserveOptions, HttpClientResponseOptions } from '../httpClientOptions';

@Injectable({ providedIn: 'root' })
export class UsersService {
  private readonly http = inject(HttpClient);
 list<TData = PaginatedUserList>(params?: UsersListParams, options?: HttpClientBodyOptions): Observable<TData>;
 list<TData = PaginatedUserList>(params?: UsersListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 list<TData = PaginatedUserList>(params?: UsersListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  list<TData = PaginatedUserList>(
    params?: UsersListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/users/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/users/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/users/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 retrieve<TData = User>(username: string, options?: HttpClientBodyOptions): Observable<TData>;
 retrieve<TData = User>(username: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 retrieve<TData = User>(username: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  retrieve<TData = User>(
    username: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/users/${username}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/users/${username}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/users/${username}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Endpoint for adding roles to users, according to the rules defined by RoleDelegation objects
 */
 addRole<TData = User>(username: string,
    addRoleRequestRequest: AddRoleRequestRequest, options?: HttpClientBodyOptions): Observable<TData>;
 addRole<TData = User>(username: string,
    addRoleRequestRequest: AddRoleRequestRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 addRole<TData = User>(username: string,
    addRoleRequestRequest: AddRoleRequestRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  addRole<TData = User>(
    username: string,
    addRoleRequestRequest: AddRoleRequestRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/users/${username}/add-role/`,
      addRoleRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/users/${username}/add-role/`,
      addRoleRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/users/${username}/add-role/`,
      addRoleRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Endpoint for removing roles from users, according to the rules defined by RoleDelegation objects
 */
 removeRole<TData = User>(username: string,
    removeRoleRequestRequest: RemoveRoleRequestRequest, options?: HttpClientBodyOptions): Observable<TData>;
 removeRole<TData = User>(username: string,
    removeRoleRequestRequest: RemoveRoleRequestRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 removeRole<TData = User>(username: string,
    removeRoleRequestRequest: RemoveRoleRequestRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  removeRole<TData = User>(
    username: string,
    removeRoleRequestRequest: RemoveRoleRequestRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/users/${username}/remove-role/`,
      removeRoleRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/users/${username}/remove-role/`,
      removeRoleRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/users/${username}/remove-role/`,
      removeRoleRequestRequest,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

